"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportModalValidationSchema = exports.enterpriseAgentSignUpValidationSchema = void 0;

var Yup = _interopRequireWildcard(require("yup"));

var _i18n = require("../i18n");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var emailRequired = Yup.string().required(_i18n.ENTERPRISE_AGENT_FLOW.FORM.EMAIL_REQUIRED).email(_i18n.ENTERPRISE_AGENT_FLOW.FORM.EMAIL_MUST_BE_VALID);
var firstNameRequired = Yup.string().required(_i18n.ENTERPRISE_AGENT_FLOW.FORM.FIRST_NAME_REQUIRED).min(2, _i18n.ENTERPRISE_AGENT_FLOW.FORM.FIRST_NAME_REQUIRED);
var lastNameRequired = Yup.string().required(_i18n.ENTERPRISE_AGENT_FLOW.FORM.LAST_NAME_REQUIRED).min(2, _i18n.ENTERPRISE_AGENT_FLOW.FORM.LAST_NAME_REQUIRED);
var companyNameRequired = Yup.string().required(_i18n.ENTERPRISE_AGENT_FLOW.FORM.COMPANY_NAME_REQUIRED).min(3, _i18n.ENTERPRISE_AGENT_FLOW.FORM.COMPANY_NAME_REQUIRED);
var validPassword = Yup.string().required(_i18n.ENTERPRISE_AGENT_FLOW.FORM.PASSWORD_REQUIRED).min(10, _i18n.ENTERPRISE_AGENT_FLOW.FORM.PASSWORD_REQUIRED).matches(/d+/, _i18n.ENTERPRISE_AGENT_FLOW.FORM.PASSWORD_REQUIRED) // At least one number
.matches(/[A-Z]/, _i18n.ENTERPRISE_AGENT_FLOW.FORM.PASSWORD_REQUIRED) // At least one uppercase letter
.matches(/[!@#$%^&*(),.?":{}|<>]/, _i18n.ENTERPRISE_AGENT_FLOW.FORM.PASSWORD_REQUIRED); // At least one special character

var enterpriseAgentSignUpValidationSchema = Yup.object().shape({
  email: emailRequired,
  firstName: firstNameRequired,
  lastName: lastNameRequired,
  companyName: companyNameRequired,
  password: validPassword
});
exports.enterpriseAgentSignUpValidationSchema = enterpriseAgentSignUpValidationSchema;
var supportModalValidationSchema = Yup.object().shape({
  email: emailRequired,
  firstName: firstNameRequired,
  lastName: lastNameRequired,
  companyName: companyNameRequired,
  businessImpact: Yup.string().required('TODO'),
  requestType: Yup.string().required('TODO'),
  imageRef: Yup.string().required('TODO')
});
exports.supportModalValidationSchema = supportModalValidationSchema;